import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Spinner from '../Spinner'
import spinner from './assets/spinner.png'
import whiteSpinner from './assets/white-spinner.png'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${Spacing.M};
  ${Media.Phone`
    padding-top: ${Spacing.S};
  `};
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};
  ${Media.Phone`
    gap: ${Spacing.S};
  `};
`
export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
  padding-bottom: ${Spacing['2XS']};
`

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: ${Spacing['2XS']};
`

export const SlashedPrice = styled.span`
  color: #92cdfc;
  text-decoration: line-through;
`

export const PriceLoader = styled(Spinner)<{ type?: 'white' | 'default' }>`
  width: 24px;
  height: 24px;
  background-image: url(${({ type }) => (type === 'white' ? whiteSpinner : spinner)});
`
export const DetailsContainer = styled.div`
  padding-top: ${Spacing.XS};
  display: flex;
  justify-content: center;
`

export const Details = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
  text-align: center;

  & span {
    ${FontWeights.DemiBold};
  }
`
